import styled, { css, keyframes } from 'styled-components';

import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

const duration = '150ms';
const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const slideIn = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
`;
const slideOut = keyframes`
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const BaseMonitoringPanel = styled(Grid)`
  background: ${({ theme }) => theme.color.noir};
  padding-top: ${({ theme }) =>
    `calc(${theme.x2spacePx}px + ${theme.safeAreaInsetTop})`};
  padding-bottom: ${({ theme }) =>
    `calc(${theme.x2spacePx}px + ${theme.safeAreaInsetBottom})`};
  color: ${({ theme }) => theme.color.white};
`;

export const MonitoringPanelLayoutMobile = styled(BaseMonitoringPanel)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  animation: ${fadeIn} ${duration} ${cubicBezier};
`;

export const MonitoringPanelLayoutTablet = styled(BaseMonitoringPanel)<{
  isOpen: boolean;
  duration: number;
}>`
  width: 100%;
  max-width: 420px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  ${({ isOpen, duration }) => {
    if (isOpen) {
      return css`
        translateX(0%);
        animation: ${slideIn} ${duration}ms ${cubicBezier};
      `;
    }

    return css`
      translateX(100%);
      animation: ${slideOut} ${duration}ms ${cubicBezier};
    `;
  }}
`;

export const MonitoringPanelLayoutDesktop = styled(BaseMonitoringPanel)`
  border-radius: ${({ theme }) => theme.x2spacePx}px;
  height: calc(100vh - 112px);
  position: sticky;
  top: 88px;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  animation: ${fadeIn} ${duration} ${cubicBezier};
`;
